import React, { useState } from 'react';
import { Eye, EyeOff, Phone } from 'lucide-react';
import { useAlert } from '../../contexts/ConfirmContext';

const Login = ({ onLogin, canInstall, onInstallClick }) => {
  const notify = useAlert();
  const [loginData, setLoginData] = useState({
    loginId: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // 로그인 처리
  const handleLogin = async () => {
    console.log('로그인 시도:', loginData);
    setLoading(true);
    setError('');

    // useAuth hook의 login 함수 호출 (API 호출도 포함)
    const result = await onLogin(loginData);
    
    if (result && !result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  // 입력값 변경 처리
  const handleChange = (field, value) => {
    setLoginData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // 계정 문의하기
  const handleAccountInquiry = async () => {
    await notify('계정 발급 및 비밀번호 초기화는 본사로 연락해주세요.\n\n📞 고객센터: 1800-6235\n🕒 운영시간: 평일 09:00~20:00\n\n※ 매장명, 담당자 성함, 아이디를 준비해주세요.\n※ 비밀번호 변경은 로그인 후 마이페이지에서 가능합니다.\n※ 부재 시 순차적으로 회신드립니다.');
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="max-w-md w-full space-y-8 p-8">
        <div className="bg-white rounded-lg shadow-md p-8">
          {/* 로고 및 제목. 안드로이드 크롬 등 설치 가능한 상태(canInstall)일
              때만 로고를 눌러 앱 설치 프롬프트를 띄운다. */}
          <div className="text-center mb-8">
            <button
              type="button"
              onClick={canInstall ? onInstallClick : undefined}
              disabled={!canInstall}
              className={`mx-auto mb-4 block ${canInstall ? 'cursor-pointer' : 'cursor-default'}`}
              title={canInstall ? '앱으로 설치하기' : undefined}
            >
              <img src="/logo192.png" alt="뽀짝" className="w-16 h-16" />
            </button>
            <h2 className="text-2xl font-bold text-gray-900">뽀짝 스탬프 적립</h2>
            <p className="text-gray-600 mt-2">매장 관리자 로그인</p>
          </div>

          {/* 로그인 폼 */}
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                매장 아이디
              </label>
              <input
                type="text"
                value={loginData.loginId}
                onChange={(e) => handleChange('loginId', e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                placeholder="매장 아이디를 입력하세요"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                비밀번호
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  value={loginData.password}
                  onChange={(e) => handleChange('password', e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 pr-10"
                  placeholder="비밀번호를 입력하세요"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md text-sm">
                {error}
              </div>
            )}

            <button
              onClick={handleLogin}
              disabled={loading || !loginData.loginId || !loginData.password}
              className="w-full bg-blue-500 text-white py-3 rounded-md hover:bg-blue-600 font-medium transition-colors disabled:opacity-50"
            >
              {loading ? '로그인 중...' : '로그인'}
            </button>
          </div>

          {/* 계정 문의 */}
          <div className="mt-6">
            <div className="text-center">
              <button
                onClick={handleAccountInquiry}
                className="text-blue-500 hover:text-blue-600 text-sm flex items-center justify-center space-x-1 mx-auto"
              >
                <Phone className="w-4 h-4" />
                <span>계정 문의 및 비밀번호 초기화</span>
              </button>
            </div>
          </div>


          {/* 고객센터 정보 */}
          {/* <div className="mt-6 p-4 bg-blue-50 rounded-md border border-blue-200">
            <div className="text-center">
              <h4 className="text-sm font-medium text-blue-800 mb-2">고객센터</h4>
              <p className="text-sm text-blue-600">
                📞 1588-0000<br />
                🕒 평일 09:00~18:00 (토/일/공휴일 휴무)
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Login;